import {
  CARREGA_MEU_CONTEXTO,
  CARREGA_MEU_CONTEXTO_SUCESSO,
  CARREGA_MEU_CONTEXTO_ERRO,
  ABRE_TROCA_CLIENTE,
  FECHA_TROCA_CLIENTE,
  BUSCA_CLIENTES_SELECIONAVEIS,
  CLIENTES_SELECIONAVEIS_SUCESSO,
  SELECIONA_CLIENTE_SEGURANCA,
  SIGNOUT_USER_SUCCESS,
} from 'constants/ActionTypes';

// Espelha MeuContextoResponse da Uzerpass.Seguranca (GET /me) — ver
// docs/plano-integracao-api-seguranca.md. Substitui gradualmente o "configuracao" do
// legado como fonte de módulos/menus/permissões/portaria.
const INIT_STATE = {
  carregando: true,
  carregado: false,
  erro: null,

  usuario: null, // { id, nome, login, ehAdministradorGlobal }
  clienteAtivo: null, // { id } | null
  multiCliente: false,
  modulos: [], // [{ id, codigo, nome, icone, menus: [ItemMenuContextoDto recursivo] }]
  permissoes: [], // [{ funcionalidade, acao }]
  portaria: null,

  // Troca de cliente
  trocaClienteAberta: false,
  buscandoClientes: false,
  buscaCliente: '',
  clientesSelecionaveis: [],
  podeSelecionarQualquerCliente: false,
};

// Vários sagas/reducers legados (Localidade, AcessoPerfil, AcessoPeriodo, AcessoBloqueio,
// AcessoFull, AcessoIdade, AcessoGenero, AcessoPessoa, PontoAcesso, LocalControlado,
// VinculoPessoa, UsuarioPlataforma...) ainda leem localStorage['idClienteFixado'] direto pra
// pré-filtrar suas telas pelo cliente ativo do usuário. Isso só era gravado pelo fluxo antigo
// (reducers/Inicio.js, a partir de GET /usuariosPortal/ClienteFixado) — removido quando o
// consumo dessa tela (combo "Cliente Fixado" já comentado) parou de ser chamado. Gravamos
// aqui, a partir do cliente ativo real (seguranca.clienteAtivo), pra essas telas voltarem a
// funcionar. Nome/imagem só ficam disponíveis quando clientesSelecionaveis já carregou —
// por isso também são atualizados em CLIENTES_SELECIONAVEIS_SUCESSO, não só aqui.
function sincronizaClienteFixadoLocalStorage(clienteAtivo, clientesSelecionaveis) {
  if (!clienteAtivo) {
    localStorage.removeItem('idClienteFixado');
    localStorage.removeItem('nomeClienteFixado');
    localStorage.removeItem('imgClienteFixado');
    return;
  }

  localStorage.setItem('idClienteFixado', clienteAtivo.id);

  const info = (clientesSelecionaveis || []).find(c => c.id === clienteAtivo.id);
  if (info) {
    localStorage.setItem('nomeClienteFixado', info.nome || '');
    localStorage.setItem('imgClienteFixado', info.imagem || '');
  }
}

function aplicaContexto(state, contexto) {
  if (!contexto) return state;

  sincronizaClienteFixadoLocalStorage(contexto.clienteAtivo || null, state.clientesSelecionaveis);

  return {
    ...state,
    carregando: false,
    carregado: true,
    erro: null,
    usuario: contexto.usuario || state.usuario,
    clienteAtivo: contexto.clienteAtivo || null,
    multiCliente: !!contexto.multiCliente,
    modulos: contexto.modulos || [],
    permissoes: contexto.permissoes || [],
    portaria: contexto.portaria || null,
  };
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CARREGA_MEU_CONTEXTO: {
      return {
        ...state,
        carregando: true,
      };
    }
    case CARREGA_MEU_CONTEXTO_SUCESSO: {
      return aplicaContexto(state, action.payload);
    }
    case CARREGA_MEU_CONTEXTO_ERRO: {
      return {
        ...state,
        carregando: false,
        erro: action.payload,
      };
    }
    case SELECIONA_CLIENTE_SEGURANCA: {
      // A resposta da seleção já é o MeuContextoResponse inteiro — tratada aqui via a
      // mesma action de sucesso do contexto (saga despacha carregaMeuContextoSucesso).
      return state;
    }
    case ABRE_TROCA_CLIENTE: {
      return {
        ...state,
        trocaClienteAberta: true,
      };
    }
    case FECHA_TROCA_CLIENTE: {
      return {
        ...state,
        trocaClienteAberta: false,
      };
    }
    case BUSCA_CLIENTES_SELECIONAVEIS: {
      return {
        ...state,
        buscandoClientes: true,
        buscaCliente: action.payload.busca || '',
      };
    }
    case CLIENTES_SELECIONAVEIS_SUCESSO: {
      const retorno = action.payload;
      const clientes = retorno.clientes || [];

      // Nome/imagem do cliente ativo podem não ter chegado ainda quando aplicaContexto rodou
      // (a lista de selecionáveis é buscada em paralelo) — sincroniza de novo agora que
      // chegou, se o cliente ativo continuar o mesmo.
      sincronizaClienteFixadoLocalStorage(state.clienteAtivo, clientes);

      return {
        ...state,
        buscandoClientes: false,
        clientesSelecionaveis: clientes,
        podeSelecionarQualquerCliente: !!retorno.podeSelecionarQualquerCliente,
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      return INIT_STATE;
    }
    default:
      return state;
  }
};
